export const unitsMap = {
    "in": "mm",
    '"': "mm",
    "inch": "mm",
    "in^2": "cm^2",
    "in^3": "cm^3",
    "in^4": "cm^4",
    "gallons": "liters",
    "gal/ft": "liters/m",
    "bbls/ft": "bbls/m",
    "lbs": "kg",
    "lbf": "kN",
    "ppf": "kg/m",
    "lbs/ft": "kg/m",
    "ft-lbs": "N-m",
    "psi": "MPa",
    "ksi": "MPa",
    "ft": "m",
    "tpi": "tpi",
    "deg/100ft": "deg/100ft",
    "degrees": "degrees"
};

export const formula = {
    Metric: {
        "in": {
            "mm": (value) => value.times(25.4)
        },
        "in^2": {
            "cm^2": (value) => value.times(6.4516)
        },
        "in^3": {
            "cm^3": (value) => value.times(16.387064)
        },
        "in^4": {
            "cm^4": (value) => value.times(41.62314256)
        },
        "ft": {
            "m": (value) => value.times(0.3048)
        },
        "gal/ft": {
            "liters/m": (value) => value.times(12.4193301)
        },
        "gallons": {
            "liters": (value) => value.times(3.78541)
        },
        "bbls/ft": {
            "bbls/m": (value) => value.times(3.281)
        },
        '"': {
            "mm": (value) => value.times(25.4)
        },
        "lbs": {
            "kN": (value) => value.times(0.004448),
            "kg": (value) => value.times(0.453592)
        },
        "lbf": {
            "kN": (value) => value.times(0.004448)
        },
        "ppf": {
            "kg/m": (value) => value.times(1.4882)
        },
        "lbs/ft": {
            "kg/m": (value) => value.times(1.4882)
        },
        "ft-lbs": {
            "N-m": (value) => value.times(1.3558179483),
            "kN": (value) => value.times(0.001355817)
        },
        "psi": {
            "MPa": (value) => value.times(0.00689475729)
        },
        "ksi": {
            "MPa": (value) => value.times(6.89475729)
        },
        "tpi": {
            "tpi": (value) => value
        },
        "deg/100ft": {
            "deg/100ft": (value) => value
        },
        "degrees": {
            "degrees": (value) => value
        }
    },
    Imperial: {
        "in": {
            "mm": (value) => value
        },
        "in^2": {
            "cm^2": (value) => value
        },
        "in^3": {
            "cm^3": (value) => value
        },
        "in^4": {
            "cm^4": (value) => value
        },
        "ft": {
            "m": (value) => value
        },
        "gal/ft": {
            "liters/m": (value) => value
        },
        "gallons": {
            "liters": (value) => value
        },
        "bbls/ft": {
            "bbls/m": (value) => value
        },
        "lbs": {
            "kN": (value) => value,
            "kg": (value) => value
        },
        "lbf": {
            "kN": (value) => value
        },
        "ppf": {
            "kg/m": (value) => value
        },
        "lbs/ft": {
            "kg/m": (value) => value
        },
        "ft-lbs": {
            "N-m": (value) => value,
            "kN": (value) => value
        },
        "psi": {
            "MPa": (value) => value
        },
        "ksi": {
            "MPa": (value) => value
        },
        '"': {
            "mm": (value) => value
        },
        "tpi": {
            "tpi": (value) => value
        },
        "deg/100ft": {
            "deg/100ft": (value) => value
        },
        "degrees": {
            "degrees": (value) => value
        }
    }
};

export const getFraction = (decimalString) => {
    let decimal = parseFloat(decimalString);
    let fraction = decimal - Math.floor(decimal);
    let floor = Math.floor(decimal);
    let tolerance = 0.00001;

    if (floor !== 0) {
        floor = `${floor} `;
    } else {
        floor = '';
    }
    
    if (fraction < tolerance) {
        return `${floor}`;
    } else if (Math.abs(fraction - 0.03125) < tolerance) {
        return `${floor}1/32`;
    } else if (Math.abs(fraction - 0.0625) < tolerance) {
        return `${floor}1/16`;
    } else if (Math.abs(fraction - 0.09375) < tolerance) {
        return `${floor}3/32`;
    } else if (Math.abs(fraction - 0.125) < tolerance) {
        return `${floor}1/8`;
    } else if (Math.abs(fraction - 0.15625) < tolerance) {
        return `${floor}5/32`;
    } else if (Math.abs(fraction - 0.1875) < tolerance) {
        return `${floor}3/16`;
    } else if (Math.abs(fraction - 0.21875) < tolerance) {
        return `${floor}7/32`;
    } else if (Math.abs(fraction - 0.25) < tolerance) {
        return `${floor}1/4`;
    } else if (Math.abs(fraction - 0.28125) < tolerance) {
        return `${floor}9/32`;
    } else if (Math.abs(fraction - 0.3125) < tolerance) {
        return `${floor}5/16`;
    } else if (Math.abs(fraction - 0.375) < tolerance) {
        return `${floor}3/8`;
    } else if (Math.abs(fraction - 0.40625) < tolerance) {
        return `${floor}13/32`;
    } else if (Math.abs(fraction - 0.4375) < tolerance) {
        return `${floor}7/16`;
    } else if (Math.abs(fraction - 0.46875) < tolerance) {
        return `${floor}15/32`;
    } else if (Math.abs(fraction - 0.5) < tolerance) {
        return `${floor}1/2`;
    } else if (Math.abs(fraction - 0.53125) < tolerance) {
        return `${floor}17/32`;
    } else if (Math.abs(fraction - 0.5625) < tolerance) {
        return `${floor}9/16`;
    } else if (Math.abs(fraction - 0.59375) < tolerance) {
        return `${floor}19/32`;
    } else if (Math.abs(fraction - 0.625) < tolerance) {
        return `${floor}5/8`;
    } else if (Math.abs(fraction - 0.65625) < tolerance) {
        return `${floor}21/32`;
    } else if (Math.abs(fraction - 0.6875) < tolerance) {
        return `${floor}11/16`;
    } else if (Math.abs(fraction - 0.71875) < tolerance) {
        return `${floor}23/32`;
    } else if (Math.abs(fraction - 0.75) < tolerance) {
        return `${floor}3/4`;
    } else if (Math.abs(fraction - 0.78125) < tolerance) {
        return `${floor}25/32`;
    } else if (Math.abs(fraction - 0.8125) < tolerance) {
        return `${floor}13/16`;
    } else if (Math.abs(fraction - 0.84375) < tolerance) {
        return `${floor}27/32`;
    } else if (Math.abs(fraction - 0.875) < tolerance) {
        return `${floor}7/8`;
    } else if (Math.abs(fraction - 0.90625) < tolerance) {
        return `${floor}29/32`;
    } else if (Math.abs(fraction - 0.9375) < tolerance) {
        return `${floor}15/16`;
    } else if (Math.abs(fraction - 0.96875) < tolerance) {
        return `${floor}31/32`;
    } else {
        return false;
    }
}
